import { feed } from "@/mocks/eventArchive";

const typeTone: Record<string, string> = {
  汇总: "bg-primary-100 text-primary-800",
  考古: "bg-secondary-100 text-secondary-900",
  动态: "bg-accent-100 text-accent-900",
  讨论: "bg-background-200 text-foreground-700",
  待证: "bg-background-200 text-foreground-700",
};

export default function FeedSection() {
  return (
    <section id="kuailiu" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="sec-kicker inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>快讯流 · 持续更新
            </span>
            <h2 className="font-head-cn mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              新动态，一条条过
            </h2>
          </div>
          <span className="inline-flex items-center gap-2 text-sm text-foreground-600">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            最后更新 · 09.04 22:10
          </span>
        </div>

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {feed.map((f, i) => (
            <div
              key={i}
              className={`flex flex-col gap-3 px-5 py-4 md:flex-row md:items-center md:gap-6 ${
                i !== feed.length - 1 ? "border-b border-background-200" : ""
              } transition-colors hover:bg-background-100`}
            >
              <span className="font-num w-28 shrink-0 whitespace-nowrap text-sm tracking-wide text-foreground-500">
                {f.stamp}
              </span>
              <span
                className={`inline-flex w-fit shrink-0 items-center rounded-sm px-2 py-0.5 text-xs font-semibold ${typeTone[f.type] || typeTone["动态"]}`}
              >
                {f.type}
              </span>
              <p className="flex-1 text-sm leading-6 text-foreground-800">{f.title}</p>
              <span className="inline-flex shrink-0 items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                <i className="ri-fire-line text-accent-600"></i>{f.hot} 讨论
              </span>
            </div>
          ))}
        </div>

        <p className="mt-4 text-xs text-foreground-500">
          快讯流仅收录可交叉核对的公开动态；传闻类信息一律标注「待证」并单列，不入主线。
        </p>
      </div>
    </section>
  );
}